import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { adminApi, tokenStore } from "../lib/adminApi";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);     // null while loading or logged out
  const [ready, setReady] = useState(false);

  const refresh = useCallback(async () => {
    if (!tokenStore.get()) {
      setUser(null);
      setReady(true);
      return;
    }
    const res = await adminApi.me();
    if (res.ok) setUser(res.data);
    else { tokenStore.clear(); setUser(null); }
    setReady(true);
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = useCallback(async (email, password) => {
    const res = await adminApi.login(email, password);
    if (!res.ok) return { ok: false, error: res.error };
    tokenStore.set(res.data.access_token);
    setUser(res.data.user);
    return { ok: true };
  }, []);

  const logout = useCallback(async () => {
    try { await adminApi.logout(); } catch (_) {}
    tokenStore.clear();
    setUser(null);
  }, []);

  return (
    <AuthCtx.Provider value={{ user, ready, login, logout, refresh }}>
      {children}
    </AuthCtx.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthCtx);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
}
